export default class CalculationErrorFilter {
  customerExternalId: number;

  customerId: string;

  competence: string;

  date: string;

  recentErrors: boolean = false;

  selectedCustomerOption: string = '';

  constructor(obj: any) {
    this.customerExternalId = obj.customerExternalId || null;
    this.customerId = obj.customerId || null;
    this.competence = obj.competence || null;
    this.date = obj.date || null;
    if (obj.recentErrors !== null || obj.recentErrors !== undefined) {
      this.recentErrors = obj.recentErrors
    }
  }

  static of(obj: any): CalculationErrorFilter {
    return new CalculationErrorFilter(obj);
  }

  static ofList(obj: any[]): CalculationErrorFilter[] {
    return obj.map(this.of)
  }

  get isTradingNameFetch(): boolean {
    return this.selectedCustomerOption === 'tradingName'
  }
}
